import React from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { BaseRouteParams } from 'hocs'
import { SecondaryTabsRow } from 'uiComponents/navigation/secondaryTabsRow'
import { MenuStepType } from './schema'
import { apfSteps } from './steps'

function ApfStepTabs({ currentStep, actions }: { currentStep: MenuStepType; actions?: React.ReactNode }) {
    const { accountSlug } = useParams<BaseRouteParams>()
    const history = useHistory()
    const location = useLocation()

    return (
        <SecondaryTabsRow
            actions={actions}
            tabs={apfSteps.map((step) => {
                const href = `/account/${accountSlug}/products/apf_studio/${step.name}${location.search}`
                return {
                    name: step.label(),
                    href,
                    current: currentStep === step.name,
                    onClick: () => history.push(href),
                }
            })}
        />
    )
}

export default ApfStepTabs
